/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Edit Action Icon
 *
 * @file EditActionIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';

const EditActionIcon = ({ className, sx, ...rest }) => (
  <SvgIcon
    {...rest}
    className={className}
    sx={sx}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M11.1797 0.585928C11.9595 -0.194943 13.2232 -0.195025 14.0029 0.585928L15.415 1.99999C16.1948 2.78101 16.1948 4.04706 15.415 4.82812L4.26172 16H0.499023C0.223403 15.9999 0 15.7761 0 15.5V11.7822L11.1797 0.585928ZM1.75 12.5068V14.25H3.53516L11.3926 6.37987L9.62891 4.6162L1.75 12.5068ZM12.7646 1.82226C12.6685 1.72602 12.5141 1.72611 12.418 1.82226L10.8652 3.37792L12.6289 5.14159L14.1768 3.59179C14.2744 3.49392 14.2744 3.33414 14.1768 3.23632L12.7646 1.82226Z" fill="currentColor" />
  </SvgIcon>
);

EditActionIcon.propTypes = {
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};

EditActionIcon.defaultProps = {
  className: undefined,
  sx: undefined
};

export default EditActionIcon;

